import React, {useEffect, useLayoutEffect, useMemo, useRef, useState} from 'react';
import {
    Box,
    VStack,
    HStack,
    Flex,
    Text,
    useColorModeValue,
    Textarea,
    Button,
    ListItem,
    useDisclosure,
    useToast,
    ListIcon,
    List,
    Icon, Tooltip, Switch,
    Collapse,
    CloseButton,
    UnorderedList,
    MenuList,
    Menu, useBreakpointValue,
} from '@chakra-ui/react';
import { ImFilePdf } from "react-icons/im";
import {useDispatch, useSelector} from "react-redux";
import {FaCheckCircle} from "react-icons/fa";
import {AiOutlineArrowRight, AiOutlineSend} from "react-icons/ai";
import SignUpScreen1 from "../Modals/SignUp/SignUpScreen1";
import SignInScreen1 from "../Modals/SignIn/SignInScreen1";
import GeneratePromptScreen2 from "../Modals/Generation/GeneratePromptScreen2";
import PricingScreen from "../Modals/Payments/PricingScreen";
import {useTranslation} from "react-i18next";
import {MessageBubbleMultidoc} from "./MessageBubbleMultidoc";
import { AiOutlineUpload } from "react-icons/ai";
import axios from "axios";
import {v4 as uuidv4} from "uuid";
import {MessageBubbleMultidoc2} from "./MessageBubbleMultidoc2";
import {ChevronDownIcon, ChevronUpIcon} from "@chakra-ui/icons";
import { FaArrowRightLong } from "react-icons/fa6";
import {
    addMessageInDocumentGeneration,
    resetCurrentChatResponseGeneration,
    setCurrentChatClaudeIDGeneration,
    setCurrentChatInputGeneration,
    setCurrentChatQuestionGeneration,
    setCurrentChatTypeGeneration,
    setCurrentChatUserIDGeneration,
    setCurrentGeneratePDF,
    setCurrentGeneratePDFPage,
    setCurrentGenerationWordCount,
    setIsGeneratePDFVisible, setIsPricingModalOpen,
    setIsResearchModeOn,
    setIsUploadSourcesModalOpen,
    updateMessageInDocumentGeneration2
} from "../../redux/reducers";
import lightTheme from "../../utils/styles";
import {useAuth} from "../../redux/AuthProvider";
import {useServerIP} from "../../redux/ServerIPContext";
import GeneratePromptScreen2Image from "../Modals/Generation/GenerationPromptScreen2Image";

export const GenerationImage = ({ theDocumentGeneration, sessionTokenGeneration, socketIDGeneration, socketGeneration,
                                    stopClaudeResponseGeneration, startGeneration, pdfRef }) => {
    const {t} = useTranslation();
    const lastMessageRef = useRef(null);
    const userBgColor = useColorModeValue(lightTheme.colors.lightGray, lightTheme.colors.lightGray);
    const claudeBgColor = useColorModeValue(lightTheme.colors.lightGray, "#2e93ea");
    const claudeColor = useColorModeValue("#000000", "#E2E8F0");
    const currentChatInputGeneration = useSelector(state => state.settings.currentChatInputGeneration);
    const breakpoint = useBreakpointValue({ base: 'base', sm: 'sm', md: 'md', lg: 'lg', xl: 'xl' });
    const isMobile = breakpoint === 'base' || breakpoint === 'sm';

    const { isTypingGeneration, setIsTypingGeneration } = useAuth();
    const {isThinkingGeneration, setIsThinkingGeneration} = useAuth();
    const generations = useSelector(state => state.documents.savedGenerations);
    const currentMessagesGeneration = generations.find(doc => doc.id === theDocumentGeneration.id).messages;
    const [isInputFocused, setIsInputFocused] = useState(false);

    const isAskVisibleGeneration = useSelector(state => state.settings.isAskVisibleGeneration);
    const isFollowUpVisibleGeneration = useSelector(state => state.settings.isFollowUpVisibleGeneration);

    const dispatch = useDispatch();
    const textareaRef = useRef(null);
    const { isOpen: isOpenSignUpScreen1, onOpen: onOpenSignUpScreen1, onClose: onCloseSignUpScreen1 } = useDisclosure();
    const { isOpen: isOpenSignInScreen1, onOpen: onOpenSignInScreen1, onClose: onCloseSignInScreen1 } = useDisclosure();
    const { isOpen: isOpenGeneratePromptScreen2, onOpen: onOpenGeneratePromptScreen2, onClose: onCloseGeneratePromptScreen2 } = useDisclosure();
    const toast = useToast();
    const [shouldReferenceSources, setShouldReferenceSources] = React.useState('true');
    const [sliderValue, setSliderValue] = React.useState(1000);
    const { isOpen: isOpenPricingScreen, onOpen: onOpenPricingScreen, onClose: onClosePricingScreen } = useDisclosure();

    const [filteredOptions, setFilteredOptions] = useState([]);
    const [showDropdown, setShowDropdown] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState(0);
    const pdfNames = generations.find(doc => doc.id === theDocumentGeneration.id).files.filter(file => file.isActive).map(file => file.name);
    const dropdownRef = useRef(null);
    const { serverIPs, setServerIPs, isDev } = useServerIP();
    const [pollKey, setPollKey] = useState(null);
    const [pollKeyChat, setPollKeyChat] = useState(null);
    const [thePrompt, setThePrompt] = useState("");
    const [theClaudeGenerationID, setTheClaudeGenerationID] = useState("");
    const [theUserGenerationID, setTheUserGenerationID] = useState("");
    const auth = useAuth();
    const [bigQueryReady, setBigQueryReady] = useState(false);
    // const [isOn, setIsOn] = React.useState(false)
    const isResearchModeOn = useSelector(state => state.settings.isResearchModeOn);
    const trackColor = isResearchModeOn ? "blue.500" : "gray.200";
    const thumbColor = isResearchModeOn ? "white" : "gray.400";

    // New state for citation notification
    const [showCitationNotification, setShowCitationNotification] = useState(false);
    const [isNotificationMinimized, setIsNotificationMinimized] = useState(false);
    const [citedFiles, setCitedFiles] = useState([]);
    const [citationNotificationShown, setCitationNotificationShown] = useState(false);

    // Add state for tracking thinking messages
    const [currentThinkingMessage, setCurrentThinkingMessage] = useState("");

// Clear thinking message when done
    useEffect(() => {
        if (!isThinkingGeneration) {
            setCurrentThinkingMessage("");
        }
    }, [isThinkingGeneration]);

    const modifiedHandleNewMessage = () => {
        if (!JSON.parse(localStorage.getItem("isProPlan")) && localStorage.getItem("isChatExceeded") === "true") {
            toast({
                title: t("(Free Plan) Chat Limit Exceeded!"),
                status: "info",
                duration: 9000,
                isClosable: true,
                position: "top",
            });
            dispatch(setIsPricingModalOpen(true));
            dispatch(setCurrentChatInputGeneration(''));
            if (textareaRef && textareaRef.current) {
                textareaRef.current.style.height = '3.5rem';
            }
            return;
        }

        if (currentMessagesGeneration && currentMessagesGeneration.length >= 3 && localStorage.getItem("userID") === null) {
            toast({
                title: t("You've reached your generation limit in guest mode!"),
                description: t("Please sign up to continue creating writing."),
                status: "info",
                duration: 9000,
                isClosable: true,
                position: "top",
            });
            onOpenSignUpScreen1();
            dispatch(setCurrentChatInputGeneration(''));
            if (textareaRef && textareaRef.current) {
                textareaRef.current.style.height = '3.5rem';
            }
            return;
        }

        if (generations.find(doc => doc.id === theDocumentGeneration.id).files.length === 0) {
            toast({
                title: t("Please upload 1 or more sources!"),
                status: "error",
                duration: 7000,
                isClosable: true,
                position: "top",
            });
            // dispatch(setCurrentChatInputGeneration(''));
            if (textareaRef && textareaRef.current) {
                textareaRef.current.style.height = '3.5rem';
            }
            return;
        }

        const chatInput = currentChatInputGeneration;
        dispatch(setCurrentChatInputGeneration(''));

        const shouldReferenceSourcesBoolean = shouldReferenceSources === 'true';

        if (isResearchModeOn) {
            startGenerationBigQuery(chatInput, 999, shouldReferenceSourcesBoolean);
        } else {
            startGeneration(chatInput, 999, shouldReferenceSourcesBoolean);
        }
        dispatch(setCurrentGenerationWordCount(sliderValue));

        dispatch(setCurrentChatInputGeneration(''));
        if (textareaRef && textareaRef.current) {
            textareaRef.current.style.height = '3.5rem';
        }
    };

    const handleKeyDown = (e) => {
        if (showDropdown) {
            if (e.key === "ArrowDown") {
                e.preventDefault();
                setSelectedIndex((prev) => Math.min(prev + 1, filteredOptions.length - 1));
            } else if (e.key === "ArrowUp") {
                e.preventDefault();
                setSelectedIndex((prev) => Math.max(prev - 1, 0));
            } else if (e.key === "Enter" && selectedIndex >= 0) {
                e.preventDefault();
                insertMention(filteredOptions[selectedIndex]);
            } else if (e.key === "Escape") {
                setShowDropdown(false);
            }
        } else {
            if (e.key === 'Enter' && !e.shiftKey) {
                e.preventDefault();
                if (currentChatInputGeneration !== "" && !isTypingGeneration && !isThinkingGeneration) {
                    modifiedHandleNewMessage();
                }
            }
        }
    };

    const handleInput = (e) => {
        const value = e.target.value;
        dispatch(setCurrentChatInputGeneration(value)); // Immediately update the state with the current value

        const cursorPosition = e.target.selectionStart; // Get the cursor's position
        const textBeforeCursor = value.slice(0, cursorPosition); // Text before the cursor

        const lastAtIndex = textBeforeCursor.lastIndexOf("@"); // Find the last '@' before the cursor
        if (lastAtIndex !== -1) {
            const query = textBeforeCursor.slice(lastAtIndex + 1).toLowerCase(); // Extract query after '@'
            const filtered = pdfNames.filter((name) =>
                name.toLowerCase().startsWith(query)
            );
            setFilteredOptions(filtered);
            setShowDropdown(filtered.length > 0);
            setSelectedIndex(0); // Always select the first item by default
        } else {
            setShowDropdown(false); // Close dropdown if '@' is not detected
        }
    };

    const insertMention = (mention) => {
        const textarea = textareaRef.current;
        if (!textarea) return;

        const cursorPosition = textarea.selectionStart;
        const textBeforeCursor = currentChatInputGeneration.slice(0, cursorPosition);
        const textAfterCursor = currentChatInputGeneration.slice(cursorPosition);

        const lastAtIndex = textBeforeCursor.lastIndexOf("@");
        const newText =
            textBeforeCursor.slice(0, lastAtIndex) + `@${mention} ` + textAfterCursor;

        // Update the textarea value
        dispatch(setCurrentChatInputGeneration(newText));

        // Calculate the new cursor position (right after the inserted mention)
        const newCursorPosition = lastAtIndex + mention.length + 2; // +2 accounts for "@" and the space after the mention

        // Set the cursor position
        setTimeout(() => {
            textarea.setSelectionRange(newCursorPosition, newCursorPosition);
            textarea.focus(); // Refocus the textarea to ensure seamless typing
        }, 0);

        setShowDropdown(false);
    };


    const handleOptionClick = (option) => {
        insertMention(option);
        textareaRef.current.focus();
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);


    useEffect(() => {
        const scrollMessageIntoView = () => {
            if (lastMessageRef.current) {
                // console.log('Height of last message:', lastMessageRef.current.offsetHeight);
                if (lastMessageRef.current.offsetHeight < 500) {
                    lastMessageRef.current.scrollIntoView({ behavior: 'instant', block: 'end' });
                }
            }
        };
        scrollMessageIntoView();

    }, [currentMessagesGeneration]);

    useEffect(() => {
        const scrollMessageIntoView = () => {
            if (lastMessageRef.current) {
                lastMessageRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' });
            }
        };
        scrollMessageIntoView();

    }, []);

    const chatContainerRef = useRef(null);

    const placeholders = [t("Enter your prompt here..."),
        t("Shift + Enter to add a new line")];
    const [currentPlaceholder, setCurrentPlaceholder] = useState(placeholders[0]);
    const [index, setIndex] = useState(0);
    const [fade, setFade] = useState(true); // State to manage fade in and out

    useEffect(() => {
        const intervalId = setInterval(() => {
            setFade(false); // Fade out the current placeholder

            setTimeout(() => {
                // After fade out, change the placeholder and fade it in
                setIndex((prevIndex) => (prevIndex + 1) % placeholders.length);
                setCurrentPlaceholder(placeholders[index]);
                setFade(true);
            }, 750); // Half the interval time to allow for fade in and fade out
        }, 1500);

        return () => clearInterval(intervalId);
    }, [index]);

    //isGeneratePDFVisible: false,
    //currentGeneratePDF: "",
    //currentGeneratePDFPage: 1,
    const isGeneratePDFVisible = useSelector(state => state.settings.isGeneratePDFVisible);
    const onCitationClick = (filename, page) => {
        console.log("Filename", filename)
        console.log("Page", page)

        // based on the filename, find the corresponding file in the generation
        const file = generations.find(doc => doc.id === theDocumentGeneration.id).files.find(file => file.name === filename);
        if (file) {
            //console.log("FILE FOUND", file);
            console.log("isGeneratePDFVisible", isGeneratePDFVisible)
            if (isGeneratePDFVisible) {
                // console.log("Here")
                dispatch(setIsGeneratePDFVisible(false));
                dispatch(setCurrentGeneratePDFPage(page));
                dispatch(setCurrentGeneratePDF(file.url))
                dispatch(setIsGeneratePDFVisible(true))
                // console.log("pdf ref here 1")
                // console.log("pdfRef", pdfRef)
                if (pdfRef && pdfRef.jumpToPage) {
                    // console.log("pdf ref here 2")
                    setTimeout(() => {
                        pdfRef.jumpToPage(page);
                    }, 100);
                }
            } else {
                // console.log("Here 22")
                dispatch(setCurrentGeneratePDFPage(page));
                dispatch(setCurrentGeneratePDF(file.url))
                dispatch(setIsGeneratePDFVisible(true))
                // if (pdfRef && pdfRef.jumpToPage) {
                //     setTimeout(() => {
                //         pdfRef.jumpToPage(page);
                //     }, 100);
                // }
            }
        }
    };

    const memoizedMessages = useMemo(() => {
        return currentMessagesGeneration.slice(-36).map((message, index, slicedArray) => {
            // console.log("MESSAGE INNER PEACE", message);
            const isLastMessage = index === slicedArray.length - 1;
            return {
                ...message,
                isLastMessage
            };
        });
    }, [currentMessagesGeneration, currentThinkingMessage, isThinkingGeneration]);

    const handleMessageCreation = (type, question, wordCount, shouldReferenceSources) => {
        const userIDHere = uuidv4();
        const claudeID = uuidv4();
        // socketGeneration.off('receive_message');
        const userMessage = {
            id: userIDHere,
            type: type,
            user: 'User',
            question: question,
            // word_count: wordCount,
            // should_reference_sources: shouldReferenceSources,
        };
        const claudeMessage = {
            id: claudeID,
            type: type,
            user: 'Gemini',
            question: question,
            // word_count: wordCount,
            // should_reference_sources: shouldReferenceSources,
            response: "",
            tableResponse: "d"
        };
        dispatch(addMessageInDocumentGeneration({ messageToAdd: userMessage, documentID: theDocumentGeneration.id }));
        dispatch(addMessageInDocumentGeneration({ messageToAdd: claudeMessage, documentID: theDocumentGeneration.id }));
        return { userGenerationID: userIDHere, claudeGenerationID: claudeID };
    }

    const startGenerationBigQuery = async (prompt, sliderValue, shouldReferenceSources) => {
        const { userGenerationID, claudeGenerationID } = handleMessageCreation("general_multidoc", prompt, sliderValue, shouldReferenceSources);
        setTheUserGenerationID(userGenerationID);
        setTheClaudeGenerationID(claudeGenerationID);
        const userID = auth.isLoggedIn ? localStorage.getItem("userID") : "11111111-1111-1111-1111-111111111111";

        dispatch(resetCurrentChatResponseGeneration());
        dispatch(setCurrentChatUserIDGeneration(userGenerationID));
        dispatch(setCurrentChatClaudeIDGeneration(claudeGenerationID));
        dispatch(setCurrentChatQuestionGeneration(prompt));
        dispatch(setCurrentChatTypeGeneration("general_multidoc"));
        setIsThinkingGeneration(true);
        setIsTypingGeneration(false);

        setThePrompt(prompt);
        try {
            console.log("USERID", localStorage.getItem("userID"));
            console.log("SOCKET ID GENERATION", socketIDGeneration);
            console.log("Multidoc ID", theDocumentGeneration.id);
            console.log("Prompt for Big Query", prompt)
            const response = await axios.post(serverIPs.SERVER_IP + '/p36b/make_big_query', {
                socketio_stream_room: socketIDGeneration,
                query: prompt,
                user_id: localStorage.getItem("userID"),
                multidoc_id: theDocumentGeneration.id,
            });
            console.log("response from /p36b/make_big_query", response)
            if (response.data.status === 200) {
                if (response.data.message.query_initiated) {
                    const key = response.data.message.progress_key;
                    setPollKeyChat(key);
                }
            }
        } catch (error) {
            console.log("/p36b/make_big_query error", error);
            toast({
                title: t('Oops, something went wrong. Please refresh the page and try again.'),
                status: "error",
                duration: 5000,
                isClosable: true,
            })
        }
    };

    useEffect(() => {
        const startBigQuerySession = async () => {
            try {
                console.log("USERID", localStorage.getItem("userID"));
                console.log("SOCKET ID GENERATION", socketIDGeneration);
                console.log("Multidoc ID", theDocumentGeneration.id);

                const response1 = await axios.post(serverIPs.SERVER_IP + '/p36b/make_multidoc_big_queryable', {
                    user_id: localStorage.getItem("userID"),
                    multidoc_id: theDocumentGeneration.id,
                });

                if (response1.data.status === 200) {
                    const response = await axios.post(serverIPs.SERVER_IP + '/p36b/start_big_query_session', {
                        socketio_stream_room: socketIDGeneration,
                        user_id: localStorage.getItem("userID"),
                        multidoc_id: theDocumentGeneration.id,
                    });
                    console.log("response from /p36b/start_big_query_session", response)
                    if (response.data.status === 200) {
                        if (response.data.message.start_session_initiated) {
                            const key = response.data.message.progress_key;
                            setPollKey(key);
                        }
                    }
                }
            } catch (error) {
                console.log("/p36b/start_big_query_session error", error);
                toast({
                    title: t('Oops, something went wrong. Please refresh the page and try again.'),
                    status: "error",
                    duration: 5000,
                    isClosable: true,
                })
            }
        };
        startBigQuerySession();

    }, []);

    useEffect(() => {
        if (!pollKey) return;

        const interval = setInterval(async () => {
            try {
                const res = await axios.post(
                    `${serverIPs.SERVER_IP}/general_progress`,
                    { key: pollKey }
                );
                console.log("RESPONE from /polling general_progress", res);
                const prog = res.data.message;
                if (prog.includes("Session created")) {
                    clearInterval(interval);
                    setBigQueryReady(true);
                }
            } catch (err) {
                console.error("Polling general_progress error", err);
            }
        }, 5000);

        return () => clearInterval(interval);
    }, [pollKey]);

    useEffect(() => {
        if (!pollKeyChat) return;
        const interval = setInterval(async () => {
            try {
                console.log("POLL KEY CHAT", pollKeyChat)
                const res = await axios.post(
                    `${serverIPs.SERVER_IP}/general_progress`,
                    { key: pollKeyChat }
                );
                console.log("RESPONE from /polling general_progress CHAT", res);
                const prog = res.data.message;
                if (prog.status.includes("completed")) {
                    // 1) build an object mapping each filename → its result text
                    const resultMap = {};
                    prog.summary.results.forEach(({ metadata: { filename }, result }) => {
                        resultMap[filename] = result;
                    });

                    // 2) pull out the honeybear summary into its own object
                    const summaryMap = {
                        honeybear_summary_of_responses: prog.honeybear_summary_of_responses
                    };

                    console.log("resultMap:", resultMap);
                    console.log("summaryMap:", summaryMap);

                    setIsThinkingGeneration(false);
                    setIsTypingGeneration(false);
                    dispatch(updateMessageInDocumentGeneration2({ messageID: theClaudeGenerationID, type: "general_multidoc",
                        user: 'Gemini', question: thePrompt, response: summaryMap.honeybear_summary_of_responses,
                        tableResponse: resultMap ,documentID: theDocumentGeneration.id }));
                    console.log("Finished THE UPDATE AFTER MESSAGE BIG QUERY")
                    clearInterval(interval);
                }
            } catch (err) {
                console.error("Polling general_progress error", err);
            }
        }, 5000);

        return () => clearInterval(interval);
    }, [pollKeyChat]);

    // Function to extract cited files from a response
    const extractCitedFiles = (response) => {
        if (!response) return [];

        const citedFilenames = new Set();

        // Pattern 1: [filename.pdf, pages x-y]
        const citationRegex1 = /\[(.*?\.pdf),\s*pages?\s*([\d,-\s]+)\]/gi;
        let match;
        while ((match = citationRegex1.exec(response)) !== null) {
            citedFilenames.add(match[1].trim());
        }

        // Pattern 2: [filename.pdf] (without pages)
        const citationRegex2 = /\[([^,\]]*\.pdf)\]/gi;
        while ((match = citationRegex2.exec(response)) !== null) {
            citedFilenames.add(match[1].trim());
        }

        // Pattern 3: Multiple files in brackets [file1.pdf, file2.pdf, file3.pdf]
        const citationRegex3 = /\[([^\]]+\.pdf(?:\s*,\s*[^\]]+\.pdf)+)\]/gi;
        while ((match = citationRegex3.exec(response)) !== null) {
            const files = match[1].split(/\s*,\s*/);
            files.forEach(file => {
                if (file.trim().endsWith('.pdf')) {
                    citedFilenames.add(file.trim());
                }
            });
        }

        return Array.from(citedFilenames);
    };

    // Check if we should show the citation notification
    useEffect(() => {
        const activeFiles = generations.find(doc => doc.id === theDocumentGeneration.id).files.filter(file => file.isActive);
        const activeFilenames = activeFiles.map(file => file.name);

        if (currentMessagesGeneration.length > 0 && !citationNotificationShown) {
            // Count the number of Gemini responses
            const geminiResponses = currentMessagesGeneration.filter(message => message.user === 'Gemini' && message.response);

            // Only show on the second Gemini response
            if (geminiResponses.length === 2) {
                const lastMessage = currentMessagesGeneration[currentMessagesGeneration.length - 1];

                if (lastMessage.user === 'Gemini' && lastMessage.response && activeFiles.length >= 1) {
                    const citedInActiveFiles = activeFiles.filter(filename => activeFilenames.includes(filename));

                    if (activeFiles.length > 0) {
                        setCitedFiles(citedInActiveFiles);
                        setShowCitationNotification(true);
                        setIsNotificationMinimized(false);
                        setCitationNotificationShown(true); // Mark as shown so it never shows again
                    }
                }
            }
        }
    }, [currentMessagesGeneration, theDocumentGeneration.id, generations, citationNotificationShown]);

    const { isOpen, onOpen, onClose } = useDisclosure();   // manual control
    return (
        <Box display="flex" flexDirection="column" justifyContent="space-between" p={0} boxShadow="sm" borderRadius="md"
             border="0px" borderColor="gray.300" h="92.5vh" maxW="100%">
            <Box h={currentMessagesGeneration.length > 0 ? '90.5%': '100%'} overflowY="auto" className={currentMessagesGeneration.length > 7 ? "delayed-survey" : "normal"}
                 ref={chatContainerRef}>
                <Flex justifyContent={'flex-start'} flexDirection={'column'} height={'100%'}>
                    {currentMessagesGeneration.length > 0 ?
                        memoizedMessages.map(({ isLastMessage, ...message }, index) => (
                            !message.tableResponse ?
                                <MessageBubbleMultidoc
                                    key={message.id}
                                    sessionToken={sessionTokenGeneration}
                                    socketID={socketIDGeneration}
                                    message={message}
                                    isLastMessage={isLastMessage}
                                    userBgColor={userBgColor}
                                    claudeBgColor={claudeBgColor}
                                    claudeColor={claudeColor}
                                    lastMessageRef={lastMessageRef}
                                    onCitationClick={onCitationClick}
                                    currentThinkingMessage={currentThinkingMessage} // Add this
                                    isThinking={isThinkingGeneration} // Add this
                                    socketGeneration={socketGeneration}
                                /> : <MessageBubbleMultidoc2
                                    key={message.id}
                                    sessionToken={sessionTokenGeneration}
                                    socketID={socketIDGeneration}
                                    message={message}
                                    isLastMessage={isLastMessage}
                                    userBgColor={userBgColor}
                                    claudeBgColor={claudeBgColor}
                                    claudeColor={claudeColor}
                                    lastMessageRef={lastMessageRef}
                                    onCitationClick={onCitationClick}
                                    socketGeneration={socketGeneration}
                                />
                        )) :

                        <Flex justifyContent={'flex-start'} flexDirection={'column'} height={"100vh"} alignItems={"center"}>
                            <VStack spacing={12} mt={5} borderWidth={0} width={'70%'} height={'100%'} align={'center'}>
                                <VStack align={'center'} width={'100%'} spacing={3}>
                                    <Text fontSize={'2xl'} fontWeight={'800'} >{t("Chat with Multiple Images")}</Text>
                                    <Text fontSize={16} fontWeight={'600'} color={'gray'}>{t("Upload your images")}</Text>
                                    <Text fontSize={16} fontWeight={'600'} color={'gray'}>{t("Ask a question, get answers.")}</Text>
                                </VStack>

                                <Flex justifyContent={'flex-start'} flexDirection={'column'} height={"100vh"} alignItems={"center"} bg={'white'}>
                                    <VStack spacing={5} align="center" bg={'white'} width={'100%'} mt={'-1.5rem'}>
                                        <VStack spacing={4}>
                                            <HStack spacing={6}>
                                                <Text fontSize="xl" fontWeight="bold">
                                                    {t("Examples")}
                                                </Text>
                                            </HStack>
                                            <VStack spacing={3} align={'center'}>
                                                {[t("Find all images containing a red Ford truck..."),
                                                    t("Transcribe the license plate from each of the 18 images"),
                                                    t("Tell me all the images that fit this theme...")].map((example, index) => (
                                                    <Button justifyContent="flex-start" variant="ghost" key={index}
                                                            width={['70%','75%', '90%', '95%', '111%']} py={'1.5rem'}
                                                            borderWidth={1} borderColor={lightTheme.colors.gray}
                                                            _hover={{ bg: lightTheme.colors.lightGray }} borderRadius={'10px'}
                                                            onClick={() => {
                                                                dispatch(setCurrentChatInputGeneration(example));
                                                                textareaRef.current.focus();
                                                            }}>
                                                        <Flex justifyContent="space-between" width="100%" alignItems="center">
                                                            <Text fontSize={"14px"} fontWeight={'600'} color={'blue'} mr={2}
                                                                  noOfLines={[2, 3, 4]} style={{ whiteSpace: 'normal', overflowWrap: 'break-word' }}>
                                                                "{example}"
                                                            </Text>
                                                            <Icon as={AiOutlineArrowRight} color={'blue'} fontWeight={'bold'}/>
                                                        </Flex>
                                                    </Button>
                                                ))}
                                            </VStack>
                                        </VStack>
                                        <VStack spacing={4}>
                                            <HStack spacing={6}>
                                                <Text fontSize="xl" fontWeight="bold">{t("Tips")}</Text>
                                            </HStack>
                                            <VStack align="center" width={'83%'} spacing={3} borderWidth={1} borderColor={lightTheme.colors.gray}
                                                    borderRadius={'10px'} p={'1.5rem'}>
                                                <List spacing={5} textAlign="start">
                                                    <ListItem key={1}>
                                                        <Flex align="start">
                                                            <ListIcon as={FaCheckCircle} color="green.500" mt={1} mr={4} />
                                                            <Text fontSize={"14px"} fontWeight={'500'}>{t("Provide clear, detailed instructions for best results.")}</Text>
                                                        </Flex>
                                                    </ListItem>
                                                    <ListItem key={2}>
                                                        <Flex align="start">
                                                            <ListIcon as={FaCheckCircle} color="green.500" mt={1} mr={4} />
                                                            <Text fontSize={"14px"} fontWeight={'500'}>{t("Provide enough context in your question so the AI knows what you want.")}</Text>
                                                        </Flex>
                                                    </ListItem>
                                                    <ListItem key={2}>
                                                        <Flex align="start">
                                                            <ListIcon as={FaCheckCircle} color="green.500" mt={1} mr={4} />
                                                            <Text fontSize={"14px"} fontWeight={'500'}>{t("Click \"View Images\" above the File viewer to toggle between different images")}</Text>
                                                        </Flex>
                                                    </ListItem>
                                                </List>
                                            </VStack>
                                        </VStack>
                                    </VStack>
                                </Flex>
                            </VStack>
                        </Flex>
                    }
                </Flex>
            </Box>
            {currentMessagesGeneration.length >= 0 ?
                <Box position="relative" mt="auto">
                    <form onSubmit={modifiedHandleNewMessage} style={{backgroundColor: 'white'}}>
                        <HStack spacing={0} width={'100%'} pt={1} bg='white' justifyContent={'flex-start'} alignItems={'flex-start'}>

                            <VStack>
                                <Button
                                    as="label"
                                    variant="outline"
                                    border="1px"
                                    borderColor="gray.300"
                                    color="black"
                                    // leftIcon={<Box fontSize="1.25rem">
                                    //     <AiOutlineUpload />
                                    // </Box>}
                                    size="sm"
                                    cursor="pointer"
                                    _hover={{ backgroundColor: 'gray.100' }}
                                    _active={{ backgroundColor: 'gray.200' }}
                                    marginLeft={'0.5rem'}
                                    onClick={() => {
                                        onOpenGeneratePromptScreen2()
                                        dispatch(setIsUploadSourcesModalOpen(true))
                                    }}
                                >
                                    Upload More Images
                                </Button>
                                <Text fontSize={'xs'} color={'gray'} fontWeight={'500'}>
                                    {generations.find(doc => doc.id === theDocumentGeneration.id).files.filter(file => file.isActive).length} images active
                                </Text>
                            </VStack>

                            <VStack align="center" h="auto" marginLeft={'0.5rem'} marginBottom={'0.4rem'}
                                    borderWidth={'1px'} marginRight={'1.4rem'}
                                    borderColor={isInputFocused ? 'blue' : lightTheme.colors.darkGray}
                                    borderRadius={'md'} flexGrow={1}>
                                <HStack width={'100%'} position={'relative'} spacing={0} align={"flex-end"}
                                        justifyContent={'space-between'}>
                                    <Textarea
                                        name="message-input"
                                        ref={textareaRef}
                                        placeholder={generations.find(doc => doc.id === theDocumentGeneration.id).files.length !== 0 ?
                                            currentPlaceholder : "Upload a source to get started"}
                                        onKeyDown={handleKeyDown}
                                        value={currentChatInputGeneration}
                                        style={{
                                            border: 'none',
                                            borderRight: 'none',
                                            borderRightColor: "white",
                                            marginRight: 0,
                                            borderTopWidth: isAskVisibleGeneration || isFollowUpVisibleGeneration ? '0px' : '1px',
                                            borderTopLeftRadius: isAskVisibleGeneration || isFollowUpVisibleGeneration ? '0px' : '10px',
                                            borderTopRightRadius: isAskVisibleGeneration || isFollowUpVisibleGeneration ? '0px' : '10px'
                                        }}
                                        _focus={{boxShadow: 'none', outline: 'none'}}
                                        onChange={handleInput}
                                        minH={'3.5rem'}
                                        onFocus={() => setIsInputFocused(true)}
                                        onBlur={() => setIsInputFocused(false)}
                                        overflowY="auto"  // Allow vertical scrollbar
                                        maxH="29rem"
                                        resize="none"  // Disable manual resizing
                                        onInput={(e) => {  // Auto-expand as text overflows
                                            e.currentTarget.style.height = 'auto';
                                            e.currentTarget.style.height = (e.currentTarget.scrollHeight) + 'px';
                                        }}
                                        required
                                        width={'92%'}
                                    />
                                    <Box width={'2.85rem'}>
                                        <Button
                                            aria-label="Send message"
                                            type="submit"
                                            isDisabled={currentChatInputGeneration === ""}
                                            position="relative"
                                            cursor="pointer"
                                            _hover={{backgroundColor: 'white'}}
                                            borderRadius="md"
                                            backgroundColor={"white"}
                                            transition="background 0.2s"
                                            height={'2.5rem'}
                                            width={'100%'}
                                            size={'32'}
                                            onClick={() => {
                                                modifiedHandleNewMessage();
                                            }}
                                        >
                                            <AiOutlineSend style={{fontSize: '22px'}}/>
                                        </Button>
                                    </Box>
                                </HStack>
                                {showDropdown && (
                                    <List
                                        ref={dropdownRef}
                                        position="absolute"
                                        bottom="4rem"
                                        left="11rem"
                                        bg="white"
                                        borderColor={'lightgray'} borderWidth={0.25}
                                        shadow={`1.5px 1.8px 0px lightgray`}
                                        borderRadius="md"
                                        maxH="17rem"
                                        overflowY="auto"
                                        zIndex={1000}
                                        width="70%"
                                    >
                                        {filteredOptions.map((option, index) => (
                                            <ListItem
                                                key={option}
                                                bg={selectedIndex === index ? "blue.600" : "white"}
                                                color={selectedIndex === index ? "white" : "black"}
                                                px={4}
                                                py={3}
                                                fontSize={15}
                                                fontWeight={500}
                                                cursor="pointer"
                                                onClick={() => handleOptionClick(option)}
                                                onMouseEnter={() => setSelectedIndex(index)}
                                            >
                                                {option}
                                            </ListItem>
                                        ))}
                                    </List>
                                )}
                            </VStack>
                        </HStack>
                    </form>
                </Box>
                : null}
            {currentMessagesGeneration.length !== 0 ?
                <Box justifyContent={"flex-end"} display={"flex"} mr={'1.4rem'} mb={2}>
                    <Text fontSize={"xs"} color={"gray"}>{t("Shift + Enter to add a new line")}</Text>
                </Box>
                : null}
            <SignUpScreen1 isOpenSignUpScreen1={isOpenSignUpScreen1} onCloseSignUpScreen1={onCloseSignUpScreen1}
                           onOpenSignInScreen1={onOpenSignInScreen1}/>
            <SignInScreen1 isOpenSignInScreen1={isOpenSignInScreen1} onCloseSignInScreen1={onCloseSignInScreen1}
                           onOpenSignUpScreen1={onOpenSignUpScreen1}/>
            <PricingScreen isOpenPricingScreen={isOpenPricingScreen}
                           onClosePricingScreen={onClosePricingScreen}
                           onOpenPricingScreen={onOpenPricingScreen}/>
            <GeneratePromptScreen2Image isOpenGeneratePromptScreen2={isOpenGeneratePromptScreen2}
                                        onCloseGeneratePromptScreen2={onCloseGeneratePromptScreen2}
                                        generation={theDocumentGeneration} sessionTokenGeneration={sessionTokenGeneration}/>
        </Box>
    );
};
